export default "__VITE_ASSET__586ed927__"